import script from "./IndustryBox.vue?vue&type=script&setup=true&lang=js"
export * from "./IndustryBox.vue?vue&type=script&setup=true&lang=js"

import "./IndustryBox.vue?vue&type=style&index=0&id=21bff622&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21bff622"]])

export default __exports__